<div style="width: 800px; ">
    <div role="rowgroup">
        <div class="table__row table__row--align-middle no-print" role="row">
            <span [formGroup]="form" class="table__cell table__cell--align-left" role="cell">
                <label *ngFor="let option of radioOptions">
                    <input type="radio"
                           formControlName="selectedOption"
                           [value]="option.value"
                           (change)="onRadioChange()" />
                    {{ option.label }}
                </label>
            </span>
            <span class="table__cell table__cell--align-right" role="cell"><button class="btn btn--hollow btn--add" onclick="window.print()">Print</button></span>
        </div>















        <div class="flex-container" role="rowgroup">
            <div class="flex-item" style="border: 1px solid #000000; width: 370px; padding-left: 10px;">
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell"><h4 class="">School Preferences Report</h4></span>
                </div>
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell">{{ schoolId }} {{ (schoolDetails$ | async)?.longName }}</span>
                </div>
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell">Educational Representative: {{ (schoolDetails$ | async)?.relationshipManager.locationCode != 9999 ? (schoolDetails$ | async)?.relationshipManager.name : '' }}</span>
                </div>
            </div>
            <div class="flex-item" style="border: 0px solid #000000; width: 40px;">

            </div>
            <div class="flex-item" style="border: 1px solid #000000; width: 370px; padding-left: 10px;">
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell"></span>
                </div>
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell"> {{ (schoolDetails$ | async)?.districtName}}</span>
                </div>
                <div class="table__row" role="row" style="border: 0px; height: 32px">
                    <span class="table__cell table__cell--align-left" role="cell">Show Programs: {{ form.get('selectedOption').value }}</span>
                </div>
            </div>
        </div>
    </div>
    <!--<div class="table__row--padded" role="row">
        <span></span>
    </div>-->
    <div id="print-content" style="column-count: 2; column-gap: 1em;">
        <div role="rowgroup" style="border: 0px solid #000000; padding: 5px; border-radius: 1px; width: 370px; break-inside: avoid;" *ngFor="let pref of ((prefSet$ | async)?.preferenceInstrumentClasses | filterByRentableItem) | filter:searchText:prefsFilter">
            <div class="table" role="grid">
                <div class="table__row table__row--align-middle" role="row" style="border: 1px solid #000000; padding: 5px; margin-left: .5px; border-radius: 1px; width: 370px; ">
                    <span class="table__cell table__cell--align-left"></span>
                    <span>{{ pref?.rentalCategory.name }}</span>
                    <span class="table__cell table__cell--align-left" *ngIf="!pref.isRentable && pref.hasSupplyPkg" style="font-style: italic; font-size: 10px;"> (Supplies only. Not Rentable for this program.)</span>
                    <span class="table__cell table__cell--align-left" *ngIf="pref.isRentable"></span>
                </div>
                <div role="rowgroup" style="border: 1px solid #000000; padding: 5px; border-radius: 1px; width: 370px; ">
                    <div class="table__row table__row--header containerPrefs" role="row">
                        <span role="columnheader">Type</span>
                        <span role="columnheader">Requirements</span>
                        <span role="columnheader">Exclusions</span>
                    </div>
                    <div role="rowgroup" *ngFor="let type of pref?.preferenceInstrumentTypes">
                        <div *ngIf="type.preferenceInstrumentCombos.length == 0" class="table__row containerPrefs" role="row" [ngClass]="{'table__row--last': true}">
                            <span role="cell">{{ type.rentalCategory.name }}</span>
                            <span role="cell">{{ '' }}</span>
                            <span role="cell">{{ '' }}</span>
                        </div>
                        <div class="table__row containerPrefs" role="row" *ngFor="let combo of type.preferenceInstrumentCombos" [ngClass]="{'table__row--last': true}">
                            <span role="cell">{{ type.rentalCategory.name }}</span>
                            <span role="cell">{{ combo.type == 0 ? combo.brand.name + (combo.size == null ? '' : "," + combo.size)  + (combo.color == null ? '' : "," + combo.color)  : '' }}</span>
                            <span role="cell">{{ combo.type == 1 ? combo.brand.name + (combo.size == null ? '' : "," + combo.size) + (combo.color == null ? '' : "," + combo.color)  : '' }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div role="rowgroup" style="border: 1px solid #000000; padding-left: 10px; border-radius: 0px; width: 370px; ">
                <div class="table__row table__row--header container" role="row">
                    <span role="columnheader">Variant</span>
                    <span role="columnheader">Product Name</span>
                    <span role="columnheader">Qty</span>
                    <span role="columnheader">Grades</span>
                </div>
                <div class="table__row container" role="row" *ngFor="let sup of (prefSet$ | async)?.supplyItems | filterByCategoryCode: pref?.rentalCategory.code" [ngClass]="{'table__row--last': true}">
                    <span role="cell">{{ sup.product.variantId }}</span>
                    <span role="cell">{{ sup.product.productName }}</span>
                    <span role="cell">{{ sup.quantity }}</span>
                    <span role="cell">{{ sup.lowGrade == null && sup.highGrade == null ? "ALL" : sup.lowGrade + "-" + sup.highGrade}}</span>
                </div>
            </div>
        </div>
        <div style="height: 30px;">
        </div>
    </div>
    <div id="print-footer"></div>
</div>
<style>
    @media print {
        .no-print {
            display: none;
        }

        body {
            margin-top: 100px;
        }

        #print-header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            border: 0px solid #000000;
            padding: 5px;
            border-radius: 1px;
            width: 800px;
            height: 100px;
            z-index: 9999;
        }

        #print-content {
            /*top: 100px*/
        }

        #print-footer {
            position: fixed;
            display: block;
            bottom: 5px;
            right: 10px;
            font-size: 12px;
            font-weight: bold;
        }
    }

    @media screen {
        #print-header {
            border: 0px solid #000000;
            padding: 5px;
            border-radius: 1px;
            width: 800px;
            height: 100px
        }

        #print-content {
            /*top: 100px*/
        }

        #print-footer {
            display: none;
        }
    }

    .container {
        width: 100%;
        display: flex;
    }

        .container span:nth-child(1) {
            width: 20%;
        }

        .container span:nth-child(2) {
            width: 55%;
        }

        .container span:nth-child(3) {
            width: 10%;
        }

        .container span:nth-child(4) {
            width: 15%;
        }

    .containerPrefs {
        width: 100%;
        display: flex;
    }

        .containerPrefs span:nth-child(1) {
            width: 25%;
        }

        .containerPrefs span:nth-child(2) {
            width: 50%;
        }

        .containerPrefs span:nth-child(3) {
            width: 25%;
        }
</style>
